<template>
    <div>
    <b-modal id="modal-upload-ec-kas-kecil" title="Upload Dokumen" @hidden="onHidden">
        <KasKecilUploadPhotoBox
            title="Upload Dokumen CA"
            :photos="docsCa"
            class="mb-3"
            @add-photo="addDoc('ca')"
            @remove-photo="index => removeDoc('ca', index)"
            @upload-photo="({ photo, file }) => onUploadFile('ca', photo, file)"
            @preview-photo="photo => openFilePreview('CA', photo)"
        />
        <KasKecilUploadPhotoBox
            title="Upload Dokumen EC"
            :photos="docsEc"
            @add-photo="addDoc('ec')"
            @remove-photo="index => removeDoc('ec', index)"
            @upload-photo="({ photo, file }) => onUploadFile('ec', photo, file)"
            @preview-photo="photo => openFilePreview('EC', photo)"
        />

        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" @click="cancel()">Batal</b-button>
            <b-button
                variant="pgiBtn"
                :disabled="isSubmitting"
                @click="onSave"
            >
                <b-spinner v-if="isSubmitting" small class="mr-1"></b-spinner>
                Simpan
            </b-button>
        </template>
    </b-modal>

    <ModalConfirm
        id="modal-confirm-upload-ec-kas-kecil"
        title="Konfirmasi Upload Dokumen"
        desc="Apakah Anda yakin ingin menyimpan dokumen ini?"
        :isSubmitting="isSubmitting"
        @submit="submitUploadEc"
    />

    <ModalKasKecilFilePreview
        id="modal-preview-file-kas-kecil-upload-ec"
        :title="activeFilePreview.title"
        :url="activeFilePreview.url"
        :type="activeFilePreview.type"
    />
    </div>
</template>

<script>
import KasKecilUploadPhotoBox from '@/components/kasKecil/KasKecilUploadPhotoBox'
import ModalKasKecilFilePreview from '@/components/modals/ModalKasKecilFilePreview'

const MAX_UPLOAD_COUNT = 2

const PRESIGNED_NAME = {
    ec: "ec-doc",
    ca: "ca-doc",
}

export default {
    name: "modal-kas-kecil-upload-ec",
    components: {
        KasKecilUploadPhotoBox,
        ModalKasKecilFilePreview,
    },
    props: {
        itemId: { type: Number, default: null },
    },
    data() {
        return {
            isSubmitting: false,
            nextPhotoIndexEc: 2,
            nextPhotoIndexCa: 2,
            docsEc: [this.createUploadFoto(1)],
            docsCa: [this.createUploadFoto(1)],
            activeFilePreview: {
                title: "Preview Dokumen",
                type: "image",
                url: "",
            },
        }
    },
    methods: {
        createUploadFoto(index) {
            return {
                index,
                file: null,
                fileName: "",
                previewUrl: "",
                publicUrl: "",
                isUploading: false,
            }
        },
        getDocs(type) {
            return type === "ca" ? this.docsCa : this.docsEc
        },
        setDocs(type, value) {
            if (type === "ca") {
                this.docsCa = value
            } else {
                this.docsEc = value
            }
        },
        getNextIndex(type) {
            return type === "ca" ? this.nextPhotoIndexCa : this.nextPhotoIndexEc
        },
        setNextIndex(type, value) {
            if (type === "ca") {
                this.nextPhotoIndexCa = value
            } else {
                this.nextPhotoIndexEc = value
            }
        },
        addDoc(type) {
            const docs = this.getDocs(type)
            if (!this.canAddUpload(docs)) return

            const nextIndex = this.getNextIndex(type)
            this.setDocs(type, [...docs, this.createUploadFoto(nextIndex)])
            this.setNextIndex(type, nextIndex + 1)
        },
        canAddUpload(files) {
            if (files.length < MAX_UPLOAD_COUNT) return true

            this.$helper.toastErr(this, `Maksimal upload ${MAX_UPLOAD_COUNT} file.`)
            return false
        },
        removeDoc(type, index) {
            const docs = this.getDocs(type)
            if (docs.length <= 1) {
                this.revokeUploadPreview(docs[0])
                this.setDocs(type, [this.createUploadFoto(1)])
                return
            }
            docs
                .filter((item) => item.index === index)
                .forEach((item) => this.revokeUploadPreview(item))
            this.setDocs(type, docs.filter((item) => item.index !== index))
        },
        hasUploadedFile(files) {
            return files.some((item) => !this.$helper.isNullOrEmpty(item.publicUrl))
        },
        hasIncompleteUpload(files) {
            return files.some((item) => this.$helper.isNullOrEmpty(item.publicUrl))
        },
        getUploadedUrls(files) {
            return files
                .map((item) => this.getUploadPath(item.publicUrl))
                .filter((url) => !this.$helper.isNullOrEmpty(url))
                .join(",")
        },
        async onUploadFile(type, item, selectedFile = null) {
            const file = selectedFile || item.file
            if (!file) return

            if (!this.isValidUploadFile(file)) {
                this.resetUploadFile(item)
                this.$helper.toastErr(this, "File harus berupa foto atau PDF.")
                return
            }

            item.isUploading = true
            this.revokeUploadPreview(item)
            item.publicUrl = ""
            item.fileName = ""
            this.$store.dispatch("loading/show", { progress: 0 })

            let response
            try {
                response = await this.$helper.uploadPresigned({
                    vue: this,
                    path: "mini-cash/create-presigned-url-ec",
                    params: {
                        fileExtension: this.getFileExtension(file),
                        name: PRESIGNED_NAME[type],
                    },
                    fileUpload: file,
                    contentType: this.getUploadContentType(file),
                    onUploadProgress: progress => this.$store.dispatch("loading/setProgress", Math.min(progress, 100)),
                    useXhr: true,
                })
            } catch (error) {
                this.$helper.parseError(this, error)
            } finally {
                item.isUploading = false
                this.$store.dispatch("loading/hide")
            }

            if (!response || !response.success) {
                this.resetUploadFile(item)
                this.$helper.toastErr(this, "Gagal upload file. Silakan coba lagi.")
                return
            }

            item.previewUrl = URL.createObjectURL(file)
            item.publicUrl = response.publicUrl
            item.fileName = file.name
        },
        onSave() {
            if (this.$helper.isNullOrEmpty(this.itemId)) {
                this.$helper.toastErr(this, "ID kas kecil tidak ditemukan.")
                return
            }

            if (!this.hasUploadedFile(this.docsEc) || !this.hasUploadedFile(this.docsCa)) {
                this.$helper.toastErr(this, "Dokumen CA dan EC wajib diupload.")
                return
            }

            if (this.hasIncompleteUpload(this.docsEc) || this.hasIncompleteUpload(this.docsCa)) {
                this.$helper.toastErr(this, "Upload dokumen wajib dilengkapi atau dihapus.")
                return
            }

            this.$bvModal.show("modal-confirm-upload-ec-kas-kecil")
        },
        submitUploadEc() {
            this.isSubmitting = true
            this.$axios.post(this.buildInputDocEcUrl()).then(() => {
                this.$helper.toastSucc(this, "Dokumen berhasil diupload.")
                this.$bvModal.hide("modal-confirm-upload-ec-kas-kecil")
                this.$bvModal.hide("modal-upload-ec-kas-kecil")
                this.$emit("success")
            }).catch((error) => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },
        buildInputDocEcUrl() {
            const params = {
                miniCashCabangId: this.itemId,
                path: this.getUploadedUrls(this.docsEc),
                pathCa: this.getUploadedUrls(this.docsCa),
            }
            const queryString = Object.keys(params)
                .map((key) => {
                    const value = params[key]
                    const normalizedValue = key === "path" || key === "pathCa" ? value : encodeURIComponent(value)
                    return `${encodeURIComponent(key)}=${normalizedValue}`
                })
                .join("&")

            return `mini-cash/input-doc-ec/?${queryString}`
        },
        resetUploadFile(item) {
            this.revokeUploadPreview(item)
            item.file = null
            item.fileName = ""
            item.publicUrl = ""
        },
        revokeUploadPreview(item) {
            if (!item.previewUrl) return

            URL.revokeObjectURL(item.previewUrl)
            item.previewUrl = ""
        },
        onHidden() {
            this.docsEc.forEach((item) => this.revokeUploadPreview(item))
            this.docsCa.forEach((item) => this.revokeUploadPreview(item))
            this.docsEc = [this.createUploadFoto(1)]
            this.docsCa = [this.createUploadFoto(1)]
            this.nextPhotoIndexEc = 2
            this.nextPhotoIndexCa = 2
        },
        openFilePreview(label, item) {
            if (!item.previewUrl) return

            this.activeFilePreview = {
                title: `Preview Dokumen ${label}`,
                type: this.getPreviewType(item.file),
                url: item.previewUrl,
            }
            this.$bvModal.show("modal-preview-file-kas-kecil-upload-ec")
        },
        getPreviewType(file) {
            if (!file) return "image"
            const type = file.type || ""
            const name = (file.name || "").toLowerCase()

            return type === "application/pdf" || name.endsWith(".pdf") ? "pdf" : "image"
        },
        getUploadPath(url) {
            if (this.$helper.isNullOrEmpty(url)) return ""
            return String(url).replace(/^https?:\/\/[^/]+\//, "")
        },
        getUploadContentType(file) {
            return (file && file.type) || "image"
        },
        getFileExtension(file) {
            const name = (file && file.name) || ""
            const extension = name.split(".").pop()
            if (extension && extension !== name) return extension.toLowerCase()

            const type = (file && file.type) || ""
            return type.split("/").pop() || ""
        },
        isValidUploadFile(file) {
            const type = (file && file.type) || ""
            const name = ((file && file.name) || "").toLowerCase()

            return type.startsWith("image/") || type === "application/pdf" || name.endsWith(".pdf")
        },
    },
    beforeDestroy() {
        this.docsEc.forEach((item) => this.revokeUploadPreview(item))
        this.docsCa.forEach((item) => this.revokeUploadPreview(item))
    },
}
</script>
